// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/membership/membership.proto" (package "base.membership", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Int64Value } from "../../google/protobuf/wrappers";
import { StringValue } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.membership.GetMembershipByAccountIdsAndNameRequest
 */
export interface GetMembershipByAccountIdsAndNameRequest {
    /**
     * @generated from protobuf field: repeated int64 accountId = 1
     */
    accountId: string[];
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 2
     */
    name?: StringValue;
}
/**
 * @generated from protobuf message base.membership.GetMembershipByAccountIdsAndNameResponse
 */
export interface GetMembershipByAccountIdsAndNameResponse {
    /**
     * @generated from protobuf field: repeated base.membership.Membership membership = 1
     */
    membership: Membership[];
}
/**
 * @generated from protobuf message base.membership.GetMembershipByAccessTokenRequest
 */
export interface GetMembershipByAccessTokenRequest {
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 1
     */
    name?: StringValue;
}
/**
 * @generated from protobuf message base.membership.GetMembershipByAccessTokenResponse
 */
export interface GetMembershipByAccessTokenResponse {
    /**
     * @generated from protobuf field: repeated base.membership.Membership membership = 1
     */
    membership: Membership[];
}
/**
 * @generated from protobuf message base.membership.CreateMembershipRequest
 */
export interface CreateMembershipRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: int32 dateRange = 2
     */
    dateRange: number;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: base.membership.AccessAuthorized accessAuthorized = 4
     */
    accessAuthorized: AccessAuthorized;
}
/**
 * @generated from protobuf message base.membership.Membership
 */
export interface Membership {
    /**
     * @generated from protobuf field: google.protobuf.Int64Value id = 1
     */
    id?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value accountId = 2
     */
    accountId?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.Int64Value expiredTimestamp = 3
     */
    expiredTimestamp?: Int64Value;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 4
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: base.membership.AccessAuthorized accessAuthorized = 5
     */
    accessAuthorized: AccessAuthorized;
}
/**
 * @generated from protobuf message base.membership.CreateMembershipResponse
 */
export interface CreateMembershipResponse {
    /**
     * @generated from protobuf field: int64 membershipId = 1
     */
    membershipId: string;
}
/**
 * @generated from protobuf message base.membership.UpdateAccessAuthorizedRequest
 */
export interface UpdateAccessAuthorizedRequest {
    /**
     * @generated from protobuf field: int64 accountId = 1
     */
    accountId: string;
    /**
     * @generated from protobuf field: google.protobuf.StringValue name = 2
     */
    name?: StringValue;
    /**
     * @generated from protobuf field: base.membership.AccessAuthorized accessAuthorized = 3
     */
    accessAuthorized: AccessAuthorized;
}
/**
 * @generated from protobuf message base.membership.UpdateAccessAuthorizedResponse
 */
export interface UpdateAccessAuthorizedResponse {
    /**
     * @generated from protobuf field: bool success = 1
     */
    success: boolean;
}
/**
 * @generated from protobuf enum base.membership.AccessAuthorized
 */
export enum AccessAuthorized {
    /**
     * @generated from protobuf enum value: ONLYAPP = 0;
     */
    ONLYAPP = 0,
    /**
     * @generated from protobuf enum value: ALL = 1;
     */
    ALL = 1,
    /**
     * @generated from protobuf enum value: ONLYPC = 2;
     */
    ONLYPC = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class GetMembershipByAccountIdsAndNameRequest$Type extends MessageType<GetMembershipByAccountIdsAndNameRequest> {
    constructor() {
        super("base.membership.GetMembershipByAccountIdsAndNameRequest", [
            { no: 1, name: "accountId", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<GetMembershipByAccountIdsAndNameRequest>): GetMembershipByAccountIdsAndNameRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = [];
        if (value !== undefined)
            reflectionMergePartial<GetMembershipByAccountIdsAndNameRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMembershipByAccountIdsAndNameRequest): GetMembershipByAccountIdsAndNameRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 accountId */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.accountId.push(reader.int64().toString());
                    else
                        message.accountId.push(reader.int64().toString());
                    break;
                case /* google.protobuf.StringValue name */ 2:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMembershipByAccountIdsAndNameRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 accountId = 1; */
        if (message.accountId.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.accountId.length; i++)
                writer.int64(message.accountId[i]);
            writer.join();
        }
        /* google.protobuf.StringValue name = 2; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.GetMembershipByAccountIdsAndNameRequest
 */
export const GetMembershipByAccountIdsAndNameRequest = new GetMembershipByAccountIdsAndNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMembershipByAccountIdsAndNameResponse$Type extends MessageType<GetMembershipByAccountIdsAndNameResponse> {
    constructor() {
        super("base.membership.GetMembershipByAccountIdsAndNameResponse", [
            { no: 1, name: "membership", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Membership }
        ]);
    }
    create(value?: PartialMessage<GetMembershipByAccountIdsAndNameResponse>): GetMembershipByAccountIdsAndNameResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.membership = [];
        if (value !== undefined)
            reflectionMergePartial<GetMembershipByAccountIdsAndNameResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMembershipByAccountIdsAndNameResponse): GetMembershipByAccountIdsAndNameResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.membership.Membership membership */ 1:
                    message.membership.push(Membership.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMembershipByAccountIdsAndNameResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.membership.Membership membership = 1; */
        for (let i = 0; i < message.membership.length; i++)
            Membership.internalBinaryWrite(message.membership[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.GetMembershipByAccountIdsAndNameResponse
 */
export const GetMembershipByAccountIdsAndNameResponse = new GetMembershipByAccountIdsAndNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMembershipByAccessTokenRequest$Type extends MessageType<GetMembershipByAccessTokenRequest> {
    constructor() {
        super("base.membership.GetMembershipByAccessTokenRequest", [
            { no: 1, name: "name", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<GetMembershipByAccessTokenRequest>): GetMembershipByAccessTokenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetMembershipByAccessTokenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMembershipByAccessTokenRequest): GetMembershipByAccessTokenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.StringValue name */ 1:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMembershipByAccessTokenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.StringValue name = 1; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.GetMembershipByAccessTokenRequest
 */
export const GetMembershipByAccessTokenRequest = new GetMembershipByAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMembershipByAccessTokenResponse$Type extends MessageType<GetMembershipByAccessTokenResponse> {
    constructor() {
        super("base.membership.GetMembershipByAccessTokenResponse", [
            { no: 1, name: "membership", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Membership }
        ]);
    }
    create(value?: PartialMessage<GetMembershipByAccessTokenResponse>): GetMembershipByAccessTokenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.membership = [];
        if (value !== undefined)
            reflectionMergePartial<GetMembershipByAccessTokenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetMembershipByAccessTokenResponse): GetMembershipByAccessTokenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated base.membership.Membership membership */ 1:
                    message.membership.push(Membership.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetMembershipByAccessTokenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated base.membership.Membership membership = 1; */
        for (let i = 0; i < message.membership.length; i++)
            Membership.internalBinaryWrite(message.membership[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.GetMembershipByAccessTokenResponse
 */
export const GetMembershipByAccessTokenResponse = new GetMembershipByAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateMembershipRequest$Type extends MessageType<CreateMembershipRequest> {
    constructor() {
        super("base.membership.CreateMembershipRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "dateRange", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "accessAuthorized", kind: "enum", T: () => ["base.membership.AccessAuthorized", AccessAuthorized] }
        ]);
    }
    create(value?: PartialMessage<CreateMembershipRequest>): CreateMembershipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.dateRange = 0;
        message.name = "";
        message.accessAuthorized = 0;
        if (value !== undefined)
            reflectionMergePartial<CreateMembershipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateMembershipRequest): CreateMembershipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* int32 dateRange */ 2:
                    message.dateRange = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* base.membership.AccessAuthorized accessAuthorized */ 4:
                    message.accessAuthorized = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateMembershipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* int32 dateRange = 2; */
        if (message.dateRange !== 0)
            writer.tag(2, WireType.Varint).int32(message.dateRange);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* base.membership.AccessAuthorized accessAuthorized = 4; */
        if (message.accessAuthorized !== 0)
            writer.tag(4, WireType.Varint).int32(message.accessAuthorized);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.CreateMembershipRequest
 */
export const CreateMembershipRequest = new CreateMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Membership$Type extends MessageType<Membership> {
    constructor() {
        super("base.membership.Membership", [
            { no: 1, name: "id", kind: "message", T: () => Int64Value },
            { no: 2, name: "accountId", kind: "message", T: () => Int64Value },
            { no: 3, name: "expiredTimestamp", kind: "message", T: () => Int64Value },
            { no: 4, name: "name", kind: "message", T: () => StringValue },
            { no: 5, name: "accessAuthorized", kind: "enum", T: () => ["base.membership.AccessAuthorized", AccessAuthorized] }
        ]);
    }
    create(value?: PartialMessage<Membership>): Membership {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessAuthorized = 0;
        if (value !== undefined)
            reflectionMergePartial<Membership>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Membership): Membership {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Int64Value id */ 1:
                    message.id = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Int64Value accountId */ 2:
                    message.accountId = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* google.protobuf.Int64Value expiredTimestamp */ 3:
                    message.expiredTimestamp = Int64Value.internalBinaryRead(reader, reader.uint32(), options, message.expiredTimestamp);
                    break;
                case /* google.protobuf.StringValue name */ 4:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* base.membership.AccessAuthorized accessAuthorized */ 5:
                    message.accessAuthorized = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Membership, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Int64Value id = 1; */
        if (message.id)
            Int64Value.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value accountId = 2; */
        if (message.accountId)
            Int64Value.internalBinaryWrite(message.accountId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Int64Value expiredTimestamp = 3; */
        if (message.expiredTimestamp)
            Int64Value.internalBinaryWrite(message.expiredTimestamp, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.StringValue name = 4; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* base.membership.AccessAuthorized accessAuthorized = 5; */
        if (message.accessAuthorized !== 0)
            writer.tag(5, WireType.Varint).int32(message.accessAuthorized);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.Membership
 */
export const Membership = new Membership$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateMembershipResponse$Type extends MessageType<CreateMembershipResponse> {
    constructor() {
        super("base.membership.CreateMembershipResponse", [
            { no: 1, name: "membershipId", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
    create(value?: PartialMessage<CreateMembershipResponse>): CreateMembershipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.membershipId = "0";
        if (value !== undefined)
            reflectionMergePartial<CreateMembershipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateMembershipResponse): CreateMembershipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 membershipId */ 1:
                    message.membershipId = reader.int64().toString();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateMembershipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 membershipId = 1; */
        if (message.membershipId !== "0")
            writer.tag(1, WireType.Varint).int64(message.membershipId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.CreateMembershipResponse
 */
export const CreateMembershipResponse = new CreateMembershipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccessAuthorizedRequest$Type extends MessageType<UpdateAccessAuthorizedRequest> {
    constructor() {
        super("base.membership.UpdateAccessAuthorizedRequest", [
            { no: 1, name: "accountId", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 2, name: "name", kind: "message", T: () => StringValue },
            { no: 3, name: "accessAuthorized", kind: "enum", T: () => ["base.membership.AccessAuthorized", AccessAuthorized] }
        ]);
    }
    create(value?: PartialMessage<UpdateAccessAuthorizedRequest>): UpdateAccessAuthorizedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountId = "0";
        message.accessAuthorized = 0;
        if (value !== undefined)
            reflectionMergePartial<UpdateAccessAuthorizedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccessAuthorizedRequest): UpdateAccessAuthorizedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 accountId */ 1:
                    message.accountId = reader.int64().toString();
                    break;
                case /* google.protobuf.StringValue name */ 2:
                    message.name = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.name);
                    break;
                case /* base.membership.AccessAuthorized accessAuthorized */ 3:
                    message.accessAuthorized = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccessAuthorizedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 accountId = 1; */
        if (message.accountId !== "0")
            writer.tag(1, WireType.Varint).int64(message.accountId);
        /* google.protobuf.StringValue name = 2; */
        if (message.name)
            StringValue.internalBinaryWrite(message.name, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* base.membership.AccessAuthorized accessAuthorized = 3; */
        if (message.accessAuthorized !== 0)
            writer.tag(3, WireType.Varint).int32(message.accessAuthorized);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.UpdateAccessAuthorizedRequest
 */
export const UpdateAccessAuthorizedRequest = new UpdateAccessAuthorizedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAccessAuthorizedResponse$Type extends MessageType<UpdateAccessAuthorizedResponse> {
    constructor() {
        super("base.membership.UpdateAccessAuthorizedResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<UpdateAccessAuthorizedResponse>): UpdateAccessAuthorizedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.success = false;
        if (value !== undefined)
            reflectionMergePartial<UpdateAccessAuthorizedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateAccessAuthorizedResponse): UpdateAccessAuthorizedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool success */ 1:
                    message.success = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateAccessAuthorizedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool success = 1; */
        if (message.success !== false)
            writer.tag(1, WireType.Varint).bool(message.success);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.membership.UpdateAccessAuthorizedResponse
 */
export const UpdateAccessAuthorizedResponse = new UpdateAccessAuthorizedResponse$Type();
/**
 * @generated ServiceType for protobuf service base.membership.MembershipService
 */
export const MembershipService = new ServiceType("base.membership.MembershipService", [
    { name: "CreateMembership", options: { "google.api.http": { post: "/base.membership.MembershipService/CreateMembership", body: "*" } }, I: CreateMembershipRequest, O: CreateMembershipResponse },
    { name: "GetMembershipByAccessToken", options: { "google.api.http": { post: "/base.membership.MembershipService/GetMembershipByAccessToken", body: "*" } }, I: GetMembershipByAccessTokenRequest, O: GetMembershipByAccessTokenResponse },
    { name: "UpdateAccessAuthorized", options: { "google.api.http": { post: "/base.membership.MembershipService/UpdateAccessAuthorized", body: "*" } }, I: UpdateAccessAuthorizedRequest, O: UpdateAccessAuthorizedResponse },
    { name: "GetMembershipByAccountIdsAndName", options: { "google.api.http": { post: "/base.membership.MembershipService/GetMembershipByAccountIdsAndName", body: "*" } }, I: GetMembershipByAccountIdsAndNameRequest, O: GetMembershipByAccountIdsAndNameResponse }
]);
